
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","getTradeBlotterAfterALotTime","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "546c5e5981fdf2e0da01.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "546c5e5981fdf2e0da01.worker.js");
					addMethods(w, methods)
					
					return w
				}
			